// Must run before pdfjs-dist (v4) loads — see polyfill notes.
import "./utils/promiseWithResolversPolyfill";

import React from "react";
import ReactDOM from "react-dom/client";

// Apply saved theme before React mounts to avoid flash
(function () {
    const theme = localStorage.getItem("theme") || "light";
    if (theme === "dark") {
        document.documentElement.classList.add("dark");
        document.documentElement.setAttribute("data-mantine-color-scheme", "dark");
    } else {
        document.documentElement.setAttribute("data-mantine-color-scheme", "light");
    }
})();
import { Toaster } from "sonner";
import App from "./App";

// Import i18n configuration
import "./i18n/config";

// react-easy-crop styles
import "react-easy-crop/react-easy-crop.css";

// Import global styles
import "./styles/global.scss";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <Toaster position="top-right" richColors expand closeButton offset={{ top: 72 }} />
    <App />
  </React.StrictMode>
);
